import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import kuwaiti from './locales/kuwaiti.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      kw: { translation: kuwaiti }
    },
    lng: 'kw', // default language
    fallbackLng: 'kw',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
